import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {

    baseUrl = `${baseUrl}/parametrizacao`

    const headers = { responseType: "arraybuffer" }

    return {
        exameComposicao(id){
            return repository.get(`${baseUrl}/exame-composicao/${id}`, headers)
        },
        relatorioExameCadastrado(queryParms) {
            return repository.get(`${baseUrl}/relatorio-exame-cadastrado?${urlUtil.serialize(queryParms)}`, headers)
        },
    }
}